import env from '../env';
import { fetchJSON } from '../helpers/fetchTools';
import {
    UserSession,
    UserLanguages
} from '../types';

interface TranslationResponse {
    [translationKey: string]: string;
}

export let translationsCache = null;

// keys for all words/phrases used in conversations
const keys = [
    'account_updated_successfully',
    'account',
    'actions',
    'activity_form',
    'activity_logged_successfully',
    'all_chat',
    'apply',
    'back_to_account',
    'back_to_lead',
    'back',
    'balance',
    'beginning_conversation',
    'blue_underline_header',
    'booked_a_call',
    'booked_meeting',
    'business',
    'cancel',
    'cant_send_message_header',
    'chat_starter',
    'cantonese',
    'choose_conversation_starter',
    'choose_valid_date_past',
    'choose_valid_date',
    'consumer',
    'contacts_noname',
    'conversations',
    'conversation_select_chat',
    'conversation_set_filters',
    'conversation_sl_no_account',
    'conversation_sl_no_result',
    'corporate',
    'date',
    'deal_value',
    'device_not_provided',
    'dnc_channel_required',
    'dont_forget_meeting_time',
    'dont_forget_notes',
    'edit_template_details',
    'edit',
    'enter_date',
    'enter_meeting_date',
    'enter_meeting_time',
    'english',
    'error_fetching_data',
    'expected_close_date',
    'expected_contract_expiry',
    'expires',
    'french',
    'filter_by_name_number',
    'filters',
    'finish',
    'for',
    'go_back_to_call',
    'help',
    'i_forgot_my_password',
    'inbox',
    'invalid_appointment_timeslot',
    'invalid_username_password',
    'launch_statflo_crm',
    'loading_ellipsis',
    'log_an_activity',
    'login',
    'logout',
    'mandarin',
    'my_chat',
    'name',
    'next_conversation',
    'next',
    'no_message_templates',
    'no_open_conversations',
    'no_search_results_found',
    'not_interested',
    'notes',
    'oops_server_problem',
    'oops_something_wrong',
    'opportunity_has_name',
    'opt_out_all',
    'opt_out_call',
    'opt_out_sms',
    'outcome',
    'plan_not_provided',
    'previous',
    'primary_contact',
    'profanity_content',
    'purchased',
    'recipient_number_is_not_sms_capable_no_calling',
    'recipient_number_is_not_sms_capable',
    'red_underline_header',
    'reply',
    'reset',
    'requested_dnc',
    'retry_sending_message',
    'search',
    'seeing_this_message_error',
    'select_an_option',
    'select_outlet',
    'send_message',
    'send',
    'sending_failed_desktop',
    'sending_failed',
    'sending',
    'sent_successfully',
    'sent',
    'should_be_dollars',
    'show_more',
    'smart_list',
    'spanish',
    'start_conversation_account',
    'start',
    'statflo_crm',
    'tap_to_load_desktop',
    'tap_to_load',
    'this_customer_has_requested_not_to_be_contacted',
    'time',
    'type_notes_here',
    'type',
    'view_account_message',
    'view_accounts_convo',
    'wait_for_reply_warning',
    'waiting_for_reply',
];

/**
 * Fetch translations data to load into the translations cache
 * @param {UserSession} session object which provides both the user's language and session ID
 * @returns {Promise}
 */
export async function fetchTranslations(session: UserSession): Promise<TranslationResponse> {
    if (!translationsCache) {
        const userLanguage: string = session.user_language || UserLanguages.ENGLISH;
        const translationUrl: string = `${env.TRANSLATION_HOST}/v1/common/translation/${userLanguage}`;
        const requestInit: RequestInit = {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: new Headers({
                'Accept': 'application/json',
                'Authorization': `Bearer ${session.token}`,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({ keys })
        };

        translationsCache = await fetchJSON(translationUrl, requestInit);

        return translationsCache;
    }
}

export function translate(key: string): string {
    return translationsCache[key] || key;
}



// WEBPACK FOOTER //
// ./src/services/TranslationsService.ts